function emailSetup(){

	// Hide the form
	function hideForm(){
		form.classList.add('is-hidden');

		// Remove the event listener
		window.removeEventListener('scroll', emailForm);

		// And never show it again
		document.cookie = "emailSubscriptionOnlyOnce=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
	}

	// Show the thank you message and hide the box
	function formSent(){
		submit.innerHTML = 'Thank you for subscribing!';
		submit.classList.add('success');

		setTimeout(hideForm, 2000);
	}

	// Get Interactive elements of the form
	const form = document.getElementsByClassName('form-email')[0];
	const close = document.getElementsByClassName('form-close')[0];
	const submit = document.getElementsByClassName('form-submit')[0];

	// Check if Wordpress has removed the form elements and create if needed
	if (form.getElementsByTagName('iframe')[0] === undefined){
		// Create the elements that Wordpress removes
		const iframe = document.createElement('iframe');
		iframe.setAttribute('name', 'hiddenframe');
		iframe.style.display = 'none';
		form.appendChild(iframe);
	}

	if (form.getElementsByTagName('input')[0] === undefined){
		const input = document.createElement('input');
		input.setAttribute('type', 'email');
		input.setAttribute('name', 'email');
		input.setAttribute('placeholder', 'Enter your email address');
		form.getElementsByTagName('fieldset')[0].insertBefore(input, submit);
	}

	// Close the form if the user ask for it
	// By clicking on the close
	close.addEventListener('click', hideForm, false);
	close.addEventListener('touchstart', hideForm, false);

	// or by pressing the ESC or SPACE key
	window.addEventListener('keydown', function(e) {
		if (e.keyCode == 27 || e.keyCode == 32) {
			hideForm();
		}
	});

	// Send the form in case of pressing enter
	form.addEventListener('keydown', function(e) {
		if (e.keyCode == 13) {
			form.submit();
			formSent();
		}
	});

	// Hide the form is they click on the submit button
	submit.addEventListener('click', formSent);
}

const emailForm = throttle(function (){

	// If the form as been shown before
	if (document.cookie.replace(/(?:(?:^|.*;\s*)emailSubscriptionOnlyOnce\s*\=\s*([^;]*).*$)|^.*$/, "$1") == "true"){
		// Remove the event listener
		window.removeEventListener('scroll', emailForm);
		return;
	}

	// Don't show the form until the user reach 33% of the essay
	if(window.scrollY < (document.body.scrollHeight / 4))
		return;

	// If the form isn't complete yet
	if (
		document.querySelector('.form-email iframe') === undefined ||
		document.querySelector('.form-email input') === undefined
	){ return; }

	// Show the form
	document.querySelector('.form-email').classList.remove('is-hidden');

}, 1000);
